/**
 * When Website.adsStaticEnabled is false, pass `null` here so managed-only builds do not show bundled static creatives.
 * @param {boolean} adsStaticEnabled - from Redux site settings
 * @param {*} fallback - static ad row from staticAds.js (or null)
 */
export function pickStaticFallback(adsStaticEnabled, fallback) {
  return adsStaticEnabled ? fallback : null;
}

export const managedPlacementToAd = (campaign, fallback) => {
  if (!campaign || !campaign.creative) return fallback ?? null;
  const cr = campaign.creative;
  const base = fallback != null && typeof fallback === 'object' ? fallback : {};
  return {
    ...base,
    id: String(campaign._id),
    managedCampaignId: String(campaign._id),
    title: cr.title || campaign.name || base.title,
    description: cr.description || base.description,
    image: cr.imageUrl || base.image,
    url: cr.destinationUrl || base.url,
    sponsor: campaign.advertiserName || base.sponsor,
    cta: cr.ctaLabel || base.cta,
  };
};
